import React, { useState, useEffect } from "react";
import { Table, ProgressBar } from "react-bootstrap";
import { fidelizacao } from "../../services/api";

const Fidelizacao = (props) => {
    const [data2, setData2] = useState([]);

    const unidades = [
        '', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara',
        'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande',
        'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador',
        'Freguesia', 'Recreio dos Bandeirantes'
    ];

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const response = await fidelizacao(data_inicio, data_fim);
            setData2(response || []);
        } catch (error) {
            console.error("Erro ao buscar dados de fidelização:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    // Variáveis para somar o total geral
    let tpr = 0;
    let trn = 0;

    // Processamento, ordenação alfabética e cálculo de evasão/totais
    const processedData = data2.map(item => {
        const pr = parseInt(item.pr) || 0;
        const rn = parseInt(item.rn) || 0;
        const rnp = parseFloat(item.rnp) || 0;
        const evasao = 100 - rnp;
        const nomeUnidade = unidades[parseInt(item.sec)] || `Unid. ${item.sec}`;

        tpr += pr;
        trn += rn;

        return {
            nome: nomeUnidade,
            pr,
            rn,
            rnp,
            evasao
        };
    }).sort((a, b) => a.nome.localeCompare(b.nome)); // Ordena em ordem alfabética pela unidade

    // Cálculos da linha de Total
    const totalRnp = tpr > 0 ? (trn / tpr) * 100 : 0;
    const totalEvasao = tpr > 0 ? 100 - totalRnp : 0;

    return (
        <div className="media mt-3">
            <div className="table-responsive shadow-sm rounded border">
                <Table hover bordered size="sm" className="text-center align-middle bg-white m-0 small">
                    <thead className="table-dark text-nowrap">
                        <tr>
                            <th className="align-middle text-start ps-3">Unidade</th>
                            <th className="align-middle">Max. Rnv.</th>
                            <th className="align-middle">Rnv.</th>
                            <th className="align-middle">% Fidelização</th>
                            <th className="align-middle">% Evasão</th>
                        </tr>
                    </thead>
                    <tbody>
                        {processedData.map((row, idx) => (
                            <tr key={idx}>
                                <td className="text-start fw-bold bg-light ps-3">
                                    {row.nome}
                                </td>
                                <td>{row.pr}</td>
                                <td>{row.rn}</td>
                                <td>
                                    {/* Exibição do valor e da barra de progresso alinhados */}
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                        <span style={{ minWidth: '50px' }}>{row.rnp.toFixed(2)}%</span>
                                        <ProgressBar
                                            now={row.rnp}
                                            style={{ width: '60px', height: '8px' }}
                                            variant="primary"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <span className={row.evasao > 50 ? "text-danger fw-bold" : ""}>
                                        {row.evasao.toFixed(2)}%
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className="fw-bolder border-top border-dark">
                        <tr className="bg-light">
                            <td className="text-start ps-3">TOTAL GERAL</td>
                            <td>{tpr}</td>
                            <td>{trn}</td>
                            <td>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <span style={{ minWidth: '50px' }}>{totalRnp.toFixed(2)}%</span>
                                    <ProgressBar
                                        now={totalRnp}
                                        style={{ width: '60px', height: '8px' }}
                                        variant="primary"
                                    />
                                </div>
                            </td>
                            <td>{totalEvasao.toFixed(2)}%</td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        </div>
    );
};

export default Fidelizacao;